module.exports = __webpack_public_path__ + "static/category-4eef83b3d1294bb90ea8c2ad412b4be2.png";